import { render, staticRenderFns } from "./HandRaiseRight.vue?vue&type=template&id=040be0fe&"
import script from "./HandRaiseRight.vue?vue&type=script&lang=js&"
export * from "./HandRaiseRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports